import { mergeObjects } from '@origin_js/helper';
import ComponentsObserver from '@origin_js/components-observer';

const defaultOptions = {
    name: 'Sortable Table',
    selectors: {
        element: '.x-variants_table_sortable-table'
    },
    sortableColumns: [],
};
class SortableTable {
    constructor (element, options) {
        this.element = element;
        this.options = mergeObjects(defaultOptions, options);
        this.sortDirections = {};
        this.init();
    }

    init () {
        this.addEventListeners();
    }

    addEventListeners () {
        const headers = this.element.querySelectorAll('th');
        headers.forEach((header, index) => {
            header.addEventListener('click', () => this.sortColumn(index));
        });
    }

    sortColumn (columnIndex) {
        if (!this.sortDirections[columnIndex]) {
            this.sortDirections[columnIndex] = 'ascending';
        } else {
            this.sortDirections[columnIndex] = this.sortDirections[columnIndex] === 'ascending' ? 'descending' : 'ascending';
        }

        let rows, switching, i, x, y, shouldSwitch;
        switching = true;

        while (switching) {
            switching = false;
            rows = this.element.rows;

            for (i = 1; i < (rows.length - 1); i++) {
                shouldSwitch = false;
                x = rows[i].getElementsByTagName('TD')[columnIndex];
                y = rows[i + 1].getElementsByTagName('TD')[columnIndex];

                if (this.shouldSwitch(x, y, this.sortDirections[columnIndex])) {
                    shouldSwitch = true;
                    break;
                }
            }

            if (shouldSwitch) {
                rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
                switching = true;
            }
        }
    }

    shouldSwitch (x, y, direction) {
        if (direction === 'ascending') {
            return x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase();
        } else {
            return x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase();
        }
    }
}

/**
 * Initializes a SortableTable element.
 * @param {Element} el - The DOM element representing the SortableTable.
 * @returns {SortableTable} The SortableTable instance.
 */
function initializeSortableTableElement (el) {
    console.log(`### Init ${defaultOptions.name} (Nexus/originPortal) ###`);
    const options = el.dataset.options ? JSON.parse(el.dataset.options) : null;
    return new SortableTable(el, options, defaultOptions);
}

/**
 * Initializes SortableTable instances.
 */
function initSortableTable () {
    const observer = new ComponentsObserver(
        {
            selector: defaultOptions.selectors.element,
            callback: initializeSortableTableElement,
        }
    );
    observer.init();
}

export default initSortableTable();
